<template>
  <div class="widget widget-availability">
    <template v-if="initial_variation_id">
      <template v-if="availability === 1">
        <div
          class="var-avail text-right d-inline-block w-100"
          :class="classes"
        >
          {{ $translate("Ecomsilio::Template.availability1") }}, {{ $translate("Ecomsilio::Template.variationShippingDuration") }}
        </div>
        <div class="var-avail-zusatz font-weight-normal text-right">
          ({{ $translate("Ecomsilio::Template.itemShippingTimeBefore") }}
          <u><a
            data-toggle="modal"
            href="#shippingscosts"
            class="text-appearance"
            :title="$translate('Ceres::Template.itemShippingCosts')"
            @click.once="$store.dispatch('loadComponent', 'shippingscosts-modal')"
          >{{ $translate("Ecomsilio::Template.shippingInformation") }}</a></u>)
        </div>
      </template>
      <template v-else-if="availability === 5 && isMainVariant === false">
        <div
          class="var-avail text-right d-inline-block w-100"
          :class="classes"
        >
          {{ $translate("Ecomsilio::Template.availability5") }}
        </div>
        <bw-availability-notification
          :item-id="currentItemId"
          :variation-id="currentVariation"
          :language="currentLanguage"
        />
      </template>
      <div
        v-else-if="availability === 5 && isMainVariant === true"
        class="var-avail text-right d-inline-block w-100"
        :class="classes"
      >
        {{ $translate("Ecomsilio::Template.availability5") }}
      </div>
      <div
        v-if="availability === 1 && isMainVariant === false"
        class="font-weight-bold mt-2"
      >
        <template v-if="currentStock < 10 && currentStock > 0">
          {{ $translate("Ecomsilio::Template.currentStock", {"count": currentStock }) }}
        </template>
        <template v-else>
          {{ $translate("Ecomsilio::Template.availableStockText") }}
        </template>
      </div>
    </template>
  </div>
</template>
<script>
export default {
    name: "CurrentVariationAvailability",
    inject: { itemId: { default: null } },
    data ()
    {
        return { initial_variation_id: 0 }
    },
    computed: {
        currentItemId ()
        {
            return this.itemId
        },
        currentLanguage ()
        {
            return this.$store.getters[this.itemId + "/currentItemVariation"].texts.lang
        },
        isMainVariant ()
        {
            if (this.$store.state.items[this.itemId].variationSelect.isVariationSelected === false)
            {
                return true
            }
            else
            {
                if (this.$store.state.items[this.itemId].variationSelect.attributes.length > 0)
                {
                    return !(this.$store.getters[this.itemId + "/currentItemVariation"].attributes.length > 0)
                }
                else
                {
                    return false
                }
            }
        },
        availability ()
        {
            if (!this.$store.state.items[this.itemId].variationSelect.isVariationSelected)
            {
                if (this.$store.getters[this.itemId + "/currentItemVariation"].item.salableVariationCount > 0)
                {
                    return 1
                }
                else
                {
                    if (this.$store.getters[this.itemId + "/currentItemVariation"].filter.isSalable)
                    {
                        return 1
                    }
                    else
                    {
                        return 5
                    }
                }
            }
            else
            {
                return this.$store.getters[this.itemId + "/currentItemVariation"].variation.availability.id
            }
        },
        classes ()
        {
            return ["availability", "var-avail-" + (this.availability)]
        },
        currentStock ()
        {
            return this.$store.getters[this.itemId + "/currentItemVariation"].stock.net
        },
        currentVariation ()
        {
            return this.$store.getters[this.itemId + "/currentItemVariation"].variation.id
        }
    },
    mounted ()
    {
        this.initial_variation_id = this.$store.state.items[this.itemId].initialVariationId
        $(function ()
        {
            $(".widget-feedback-average").click(function ()
            {
                $(".nav-item>a.nav-link:contains(\"Bewertungen\"), .nav-item>a.nav-link:contains(\"Reviews\")")[0].click()
                $("html, body").animate({ scrollTop: $(".nav-tabs").offset().top }, 500)
            })
        })
    }
}
</script>
